import React from 'react';
import axios from "axios";
import qs from 'qs';
import {CaptionListProps} from "../types/caption";
// import {seta} from 'jotai'
// 데이터 가져오기 (공용함수)

export async function fetchAxiosGet(url: string) {

  const config = {
    method: 'get',
    url: url,
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }


}

// 데이터 입력하기 (공용함수)
export async function setAxiosPost(url: string, data: string) {
  const config = {
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }

}

export function setExport2txt(url: string, set_url: string, job_id: string, user_id: string, captionList: CaptionListProps[], AICaptionList:CaptionListProps[], setSave: any) {

  const captionListForSave = captionList.map(caption => {
    return {
      seq: caption.seq,
      time_ini: caption.time_ini.trim().replace('.', ','),
      time_end: caption.time_end.trim().replace('.', ','),
      caption: caption.caption,
    }
    // return caption
  });


  const AICaptionListForSave = AICaptionList.map(caption => {
    return {
      seq: caption.seq,
      time_ini: caption.time_ini.trim().replace('.', ','),
      time_end: caption.time_end.trim().replace('.', ','),
      caption: caption.caption,
    }
    // return caption
  });

  const upload_url = url;
  const data = qs.stringify({
    'job_id': job_id,
    'user_id': user_id,
    'data': JSON.stringify(captionListForSave.slice(1)),
    'reference_data': JSON.stringify(AICaptionListForSave.slice(1))
  });


  const response = setAxiosPost(upload_url, data)
    .then((res) => {
      const set_caption_url = set_url + `&srt_url=${res.srt_url}&srt_file_url=${res.srt_file_url}&srt_reference_url=${res.srt_reference_url}`
      fetchAxiosGet(set_caption_url)
        .then((result)=> {

          if(result.result_code == 100) {
            //alert("result_code : " + result.data.result_code + "\nmessage : " + result.data.message);
            setSave({needSaveOn: false})
            alert ("저장 완료 하였습니다.");
          }

        })

      return true


    });

  return response;
}


